export const XClose = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.99984 17.3327C4.39734 17.3327 0.666504 13.6018 0.666504 8.99935C0.666504 4.39685 4.39734 0.666016 8.99984 0.666016C13.6023 0.666016 17.3332 4.39685 17.3332 8.99935C17.3332 13.6018 13.6023 17.3327 8.99984 17.3327ZM8.99984 15.666C10.7679 15.666 12.4636 14.9636 13.7139 13.7134C14.9641 12.4632 15.6665 10.7675 15.6665 8.99935C15.6665 7.23124 14.9641 5.53555 13.7139 4.2853C12.4636 3.03506 10.7679 2.33268 8.99984 2.33268C7.23173 2.33268 5.53604 3.03506 4.28579 4.2853C3.03555 5.53555 2.33317 7.23124 2.33317 8.99935C2.33317 10.7675 3.03555 12.4632 4.28579 13.7134C5.53604 14.9636 7.23173 15.666 8.99984 15.666ZM8.99984 7.82102L11.3565 5.46352L12.5357 6.64268L10.1782 8.99935L12.5357 11.356L11.3565 12.5352L8.99984 10.1777L6.64317 12.5352L5.464 11.356L7.8215 8.99935L5.464 6.64268L6.64317 5.46352L8.99984 7.82102Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const XCloseGray = ({ size = 24 }: { size?: number }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const XCloseBG = () => {
	return (
		<svg
			width="83"
			height="82"
			viewBox="0 0 83 82"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="2.19434"
				y="1.5"
				width="78.6062"
				height="78.6062"
				rx="39.3031"
				fill="#E50AAC"
				stroke="white"
				strokeWidth="3"
			/>
			<path
				d="M13.9998 27.3337C6.63584 27.3337 0.666504 21.3643 0.666504 14.0003C0.666504 6.63633 6.63584 0.666992 13.9998 0.666992C21.3638 0.666992 27.3332 6.63633 27.3332 14.0003C27.3332 21.3643 21.3638 27.3337 13.9998 27.3337ZM13.9998 12.115L10.2292 8.34299L8.3425 10.2297L12.1145 14.0003L8.3425 17.771L10.2292 19.6577L13.9998 15.8857L17.7705 19.6577L19.6572 17.771L15.8852 14.0003L19.6572 10.2297L17.7705 8.34299L13.9998 12.115Z"
				fill="white"
				transform="translate(27, 27)"
			/>
		</svg>
	);
};

export const XCloseBin = () => {
	return (
		<svg
			width="83"
			height="82"
			viewBox="0 0 83 82"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="2.19434"
				y="1.5"
				width="78.6062"
				height="78.6062"
				rx="39.3031"
				fill="#E50AAC"
				stroke="white"
				strokeWidth="3"
			/>
			<g clipPath="url(#clip0_249_8946)">
				<path
					d="M9.33317 8.00033V4.00033C9.33317 3.6467 9.47365 3.30756 9.7237 3.05752C9.97374 2.80747 10.3129 2.66699 10.6665 2.66699H21.3332C21.6868 2.66699 22.0259 2.80747 22.276 3.05752C22.526 3.30756 22.6665 3.6467 22.6665 4.00033V8.00033H29.3332V10.667H26.6665V28.0003C26.6665 28.3539 26.526 28.6931 26.276 28.9431C26.0259 29.1932 25.6868 29.3337 25.3332 29.3337H6.6665C6.31288 29.3337 5.97374 29.1932 5.7237 28.9431C5.47365 28.6931 5.33317 28.3539 5.33317 28.0003V10.667H2.6665V8.00033H9.33317ZM17.8852 18.667L20.2425 16.3097L18.3572 14.4243L15.9998 16.7817L13.6425 14.4243L11.7572 16.3097L14.1145 18.667L11.7572 21.0243L13.6425 22.9097L15.9998 20.5523L18.3572 22.9097L20.2425 21.0243L17.8852 18.667ZM11.9998 5.33366V8.00033H19.9998V5.33366H11.9998Z"
					fill="white"
					transform="translate(25, 24)"
				/>
			</g>
			<defs>
				<clipPath id="clip0_249_8946">
					<rect
						width="82"
						height="82"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const XClose2 = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="23"
			height="23"
			viewBox="0 0 23 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.54625 22.3465C2.33194 23.1189 3.66362 23.1056 4.38272 22.3731L11.9866 14.7693L19.5905 22.3731C20.3362 23.1189 21.6546 23.1189 22.4136 22.3465C23.186 21.5608 23.1993 20.2691 22.4403 19.51L14.8497 11.9062L22.4403 4.31561C23.1993 3.55655 23.1993 2.25151 22.4136 1.47914C21.6412 0.706764 20.3362 0.706764 19.5905 1.4525L11.9866 9.05637L4.38272 1.4525C3.66362 0.720081 2.31863 0.693448 1.54625 1.47914C0.773881 2.25151 0.800515 3.58318 1.51962 4.31561L9.13681 11.9062L1.51962 19.5233C0.800515 20.2425 0.773881 21.5874 1.54625 22.3465Z"
				fill="currentColor"
			/>
		</svg>
	);
};
